const tr: Record<string, string> = {
  // Navigation
  'nav.markets': 'Piyasalar',
  'nav.stocks': 'Hisseler',
  'nav.crypto': 'Kripto',
  'nav.news': 'Haberler',
  'nav.brokers': 'Aracı Kurumlar',
  'nav.home': 'Anasayfa',
  'nav.search': 'Ara',
  'nav.guides': 'Rehber',

  // GlobalMarkets regions
  'region.us': 'Amerika Borsaları',
  'region.eu': 'Avrupa Borsaları',
  'region.apac': 'Asya-Pasifik Borsaları',
  'region.americas': 'Amerika Kıtası',
  'region.mea': 'Ortadoğu & Afrika',

  // Table headers
  'th.exchange': 'Borsa',
  'th.last': 'Son',
  'th.percent': '%',
  'th.change': 'Fark',
  'th.monthly': 'Aylık(%)',
  'th.yearly': 'Yıllık(%)',
  'th.name': 'İsim',
  'th.lastPrice': 'Son Fiyat',
  'th.changePercent': 'Fark %',
  'th.volume': 'Hac.',
  'th.stock': 'Hisse',
  'th.price': 'Fiyat',
  'th.low': 'En Düşük',
  'th.high': 'En Yüksek',
  'th.marketCap': 'Piyasa Değeri',
  'th.institution': 'Kurum',

  // Sidebar tabs & sections
  'sidebar.markets': 'Piyasalar',
  'sidebar.brokers': 'Aracı Kurumlar',
  'sidebar.indices': 'Endeksler',
  'sidebar.forex': 'Dövizler',
  'sidebar.commodities': 'Emtia',
  'sidebar.stocks': 'Hisseler',
  'sidebar.movers': 'Piyasaya Yön Verenler',
  'sidebar.active': 'En Aktif',
  'sidebar.gainers': 'Kar Eden %',
  'sidebar.losers': 'Zarar Eden %',
  'sidebar.leading': 'Öncü Hisseler',
  'sidebar.latestNews': 'Son Haberler',
  'sidebar.showMore': 'Daha fazla göster',
  'sidebar.platforms': 'Yatırım Platformları',
  'sidebar.platformsDesc': 'Türkiye\'nin öncü aracı kurumları ve komisyon oranları.',
  'sidebar.viewAll': 'Tüm platformları gör',
  'sidebar.disclaimer': 'Komisyon oranları bilgi amaçlıdır. Güncel koşullar için ilgili kurumun web sitesini ziyaret ediniz.',

  // FeaturedNews
  'featured.breaking': 'Son Dakika Haberleri',
  'featured.viewAll': 'Tüm Haberleri Gör →',

  // SearchBar
  'search.placeholder': 'Hisse, döviz, kripto ara...',
  'search.popular': 'Popüler Aramalar',
  'search.searching': 'Aranıyor...',
  'search.noResults': 'Sonuç bulunamadı',
  'search.cancel': 'Vazgeç',

  // SearchBar categories
  'cat.index': 'Endeks',
  'cat.bist': 'Türkiye',
  'cat.us': 'ABD',
  'cat.eu': 'Avrupa',
  'cat.japan': 'Japonya',
  'cat.hkchina': 'HK/Çin',
  'cat.korea': 'Kore',
  'cat.india': 'Hindistan',
  'cat.forex': 'Döviz',
  'cat.crypto': 'Kripto',
  'cat.commodity': 'Emtia',

  // TickerBar
  'ticker.gold': 'Altın',
  'live': 'CANLI',

  // Periods
  'period.daily': 'Günlük',
  'period.weekly': 'Haftalık',
  'period.monthly': 'Aylık',
  'period.yearly': 'Yıllık',
  'period.5year': '5 Yıllık',

  // Status messages
  'status.loading': 'Yükleniyor...',
  'status.loadingData': 'Veriler yükleniyor...',
  'status.loadingChart': 'Grafik yükleniyor...',
  'status.loadingNews': 'Haberler yükleniyor...',
  'status.loadingMarket': 'Piyasa verileri yükleniyor...',
  'status.noData': 'Endeks verisi bulunamadı',
  'status.noResults': 'Arama sonucu bulunamadı',

  // News categories
  'news.all': 'Tümü',
  'news.markets': 'Piyasalar',
  'news.economy': 'Ekonomi',
  'news.earnings': 'Bilançolar',
  'news.world': 'Dünya',
  'news.energy': 'Enerji',
  'news.tech': 'Teknoloji',
  'news.crypto': 'Kripto',
  'news.byline': 'Borsaya Haber Merkezi',
  'news.dataDelay': 'Fiyat verileri bilgilendirme amaçlıdır ve gecikmeli olabilir. Yatırım tavsiyesi değildir.',
  'news.forexCommodity': 'Döviz & Emtia',
  'news.guide': 'Rehber',

  // News page
  'news.title': 'Finans ve Piyasa Haberleri',
  'news.desc': 'Son dakika küresel haberler.',
  'news.item': 'haber',
  'news.notFound': 'Haber bulunamadı',
  'news.emptyCategory': 'Bu kategoride henüz haber bulunmuyor.',
  'news.searchPlaceholder': 'Haberlerde ara...',
  'news.searchResults': '{count} haber bulundu',
  'news.clearSearch': 'Aramayı temizle',
  'news.prev': '← Önceki',
  'news.next': 'Sonraki →',

  // NewsDetail
  'detail.notFound': 'Haber bulunamadı',
  'detail.notFoundDesc': 'Aradığınız haber mevcut değil veya kaldırılmış olabilir.',
  'detail.backHome': 'Ana Sayfaya Dön',
  'detail.readMin': 'dk okuma',
  'detail.relatedNews': 'İlgili Haberler',
  'detail.noRelated': 'Henüz ilgili haber yok.',
  'detail.viewAll': 'Tüm Haberleri Gör →',
  'detail.share': 'Paylaş',
  'detail.copyLink': 'Linki Kopyala',
  'detail.copied': 'Kopyalandı!',
  'detail.comments': 'Yorumlar',
  'detail.writeComment': 'Yorum yaz...',
  'detail.reply': 'Yanıtla',
  'detail.showMoreComments': 'Daha fazla yorum göster',
  'detail.firstName': 'Ad',
  'detail.lastName': 'Soyad',
  'detail.email': 'E-posta',
  'detail.submitComment': 'Yorum Gönder',
  'detail.noComments': 'Henüz yorum yapılmamış. İlk yorumu siz yapın!',
  'detail.commentSuccess': 'Yorumunuz eklendi!',
  'detail.report': 'Şikayet Et',
  'detail.reportSpam': 'Spam',
  'detail.reportOffensive': 'Hakaret / Küfür',
  'detail.reportMisleading': 'Yanıltıcı Bilgi',
  'detail.reportAd': 'Reklam / Tanıtım',
  'detail.reportOther': 'Diğer',
  'detail.reported': 'Şikayet edildi',
  'detail.alreadyReported': 'Bu yorumu zaten şikayet ettiniz',
  'detail.listen': 'Sesli Oku',
  'detail.listening': 'Okunuyor...',
  'detail.pause': 'Duraklat',
  'detail.resume': 'Devam Et',
  'detail.stop': 'Durdur',
  'detail.relatedSymbols': 'İlgili Semboller',

  // Time
  'time.justNow': 'Az önce',
  'time.minsAgo': 'dk önce',
  'time.hoursAgo': 'saat önce',
  'time.daysAgo': 'gün önce',

  // StocksPage
  'stocks.title': 'Küresel Hisse Senetleri',
  'stocks.pageTitle': 'Hisse Senetleri — Canlı Fiyat ve Grafikler',
  'stocks.desc': 'ABD, Avrupa ve Asya borsalarından hisse senedi fiyatlarını canlı takip edin. Günlük değişim, işlem hacmi, aylık ve yıllık performans tek ekranda.',
  'stocks.topGainers': 'En Çok Yükselen',
  'stocks.topLosers': 'En Çok Düşen',
  'stocks.mostActive': 'En Aktif',
  'stocks.searchPlaceholder': 'Hisse ara...',
  'stocks.listed': 'hisse listeleniyor',
  'stocks.all': 'Tümü',
  'stocks.asia': 'Asya',
  'stocks.bank': 'Banka',
  'stocks.industry': 'Sanayi',
  'stocks.services': 'Hizmet',
  'stocks.japan': 'Japonya',
  'stocks.southKorea': 'Güney Kore',
  'stocks.india': 'Hindistan',
  'stocks.china': 'Çin',
  'stocks.taiwan': 'Tayvan',
  'stocks.indonesia': 'Endonezya',
  'stocks.australia': 'Avustralya',
  'stocks.americas': 'Diğer Amerika',
  'stocks.mea': 'Ortadoğu & Afrika',
  'stocks.canada': 'Kanada',
  'stocks.brazil': 'Brezilya',
  'stocks.saudiArabia': 'Suudi Arabistan',

  // BrokersPage
  'brokers.title': 'Aracı Kurumlar',
  'brokers.h1': 'Aracı Kurum ve Komisyon Karşılaştırması',
  'brokers.pageTitle': 'Aracı Kurumlar — Komisyon Karşılaştırması',
  'brokers.desc': 'Aracı kurumların komisyon oranlarını, platform özelliklerini ve sundukları yatırım araçlarını karşılaştırın. Size uygun kurumu kolayca seçin.',
  'brokers.platforms': 'Yatırım Platformları',
  'brokers.commission': 'Komisyon Karşılaştırması',
  'brokers.zeroComm': 'Sıfır Komisyon',
  'brokers.disclaimer': 'Komisyon oranları bilgi amaçlıdır ve kurumlar tarafından değiştirilebilir. Güncel oran ve koşullar için ilgili aracı kurumun web sitesini ziyaret ediniz. Borsaya.com yatırım tavsiyesi vermez.',

  // Broker descriptions
  'brokers.midas': 'Sıfır komisyonlu yerli yatırım platformu. Türkiye, ABD ve Avrupa hisselerine tek uygulamadan erişim.',
  'brokers.garanti': 'Garanti BBVA bünyesindeki tam kapsamlı aracı kurum. Garanti Yatırım Trader uygulaması ile mobil işlem.',
  'brokers.is': 'Türkiye\'nin en büyük aracı kurumu. İşTeFon uygulaması ile hızlı emir, analiz ve portföy yönetimi.',
  'brokers.ak': 'Akbank grubunun aracı kurumu. TradeAll platformu ile gelişmiş grafik ve analiz araçları.',
  'brokers.yapikredi': 'Yapı Kredi Bankası\'nın yatırım kuruluşu. Borsa, vadeli işlemler ve yurt dışı piyasalarda köklü aracılık hizmeti.',
  'brokers.deniz': 'DenizBank\'ın yatırım kuruluşu. Hisse senedi, vadeli işlemler ve yatırım danışmanlığı hizmetleri.',
  'brokers.teb': 'Türk Ekonomi Bankası\'nın yatırım kuruluşu. Borsa ve vadeli işlem piyasalarında aracılık hizmetleri.',
  'brokers.ziraat': 'T.C. Ziraat Bankası\'nın yatırım kuruluşu. Geniş şube ağı üzerinden bireysel ve kurumsal yatırımcılara hizmet.',
  'brokers.vakif': 'Vakıfbank\'ın yatırım kuruluşu. Hisse senedi, tahvil, fon ve vadeli işlem piyasalarında geniş seçenekler.',
  'brokers.halk': 'T. Halk Bankası\'nın yatırım kuruluşu. 1000\'den fazla banka şubesi aracılığıyla bireysel yatırımcılara hizmet.',
  'brokers.qnb': 'QNB Finansbank\'ın yatırım kuruluşu. Borsa, vadeli işlemler ve yurt dışı piyasalarda hizmet.',
  'brokers.oyak': 'OYAK grubu bünyesinde faaliyet gösteren aracı kurum. Borsa ve vadeli işlem piyasalarında geniş hizmet yelpazesi.',
  'brokers.gedik': 'SPK lisanslı bağımsız aracı kurum. Hisse senedi, VİOP, yurt dışı piyasalar ve yatırım danışmanlığı.',
  'brokers.tera': '1990\'dan bu yana hisse senedi, VİOP ve yatırım danışmanlığı alanlarında bireysel ve kurumsal hizmet.',
  'brokers.gcm': 'VİOP ve borsa işlemlerinde uzmanlaşmış, teknoloji odaklı çevrimiçi yatırım platformu.',
  'brokers.unlu': 'ÜNLÜ & Co grubunun yatırım kuruluşu. Hisse senedi, varant, yurt dışı borsalar ve kurumsal finansman.',
  'brokers.tacirler': '1991\'den bu yana hisse senedi, portföy yönetimi ve yatırım danışmanlığı hizmetleri sunan köklü kurum.',
  'brokers.integral': 'Hisse senedi, halka arz aracılığı ve kurumsal finansman hizmetleri sunan SPK lisanslı aracı kurum.',
  'brokers.info': 'Hedef Holding bünyesinde 1994\'ten bu yana bireysel ve kurumsal yatırımcılara canlı borsa ve analiz hizmeti.',
  'brokers.seker': 'Şekerbank iştiraki. 1996\'dan bu yana bireysel ve kurumsal yatırımcılara geniş yatırım ürünleri.',
  'brokers.global': '1990\'dan bu yana 30 yılı aşkın deneyimle hisse senedi, vadeli işlem ve portföy yönetimi hizmetleri.',
  'brokers.alb': 'ALB Yatırım\'dan Pusula Yatırım adıyla yeniden yapılanan aracı kurum. Hisse senedi ve vadeli işlem.',
  'brokers.ahlatci': 'Ahlatçı Holding bünyesinde hızlı ve güvenilir işlem altyapısıyla bireysel yatırımcılara hizmet.',
  'brokers.piramit': '1991\'den bu yana hisse senedi ve VİOP işlemlerinde bireysel yatırımcılara odaklanan bağımsız aracı kurum.',
  'brokers.inter': 'İstanbul merkezli SPK lisanslı aracı kurum. Borsa ve sermaye piyasası işlemlerinde aracılık hizmetleri.',
  'brokers.burgan': 'Burgan Bank iştiraki. Bireysel ve kurumsal yatırımcılara aracılık, kurumsal finansman ve varlık yönetimi.',
  'brokers.hedef': 'Hedef Holding bünyesinde yatırım bankacılığı alanında faaliyet gösteren lisanslı yatırım bankası.',

  // Footer
  'footer.desc': 'Nasdaq, S&P 500, DAX ve 80+ küresel borsadan hisse senedi fiyatları, döviz kurları, kripto para verileri, piyasa haberleri ve teknik analizler. Tüm yatırım araçları tek platformda.',
  'footer.markets': 'Piyasalar',
  'footer.explore': 'Keşfet',
  'footer.info': 'Bilgi',
  'footer.gold': 'Altın',
  'footer.dollarTl': 'Dolar/TL',
  'footer.about': 'Hakkımızda',
  'footer.contact': 'İletişim',
  'footer.privacy': 'Gizlilik Politikası',
  'footer.terms': 'Kullanım Koşulları',
  'footer.cookieSettings': 'Çerez Tercihleri',
  'footer.copyright': '© 2026 Borsaya.com — Tüm hakları saklıdır.',
  'footer.disclaimer': 'Borsaya.com bir yatırım danışmanlık kuruluşu değildir ve yatırım danışmanlık hizmeti sunmamaktadır. Bu platformda yer alan tüm veriler, haberler, analizler ve içerikler yalnızca genel bilgilendirme amacıyla sunulmakta olup herhangi bir menkul kıymetin alım-satım önerisi ya da yatırım tavsiyesi niteliği taşımamaktadır. Yatırım kararları tamamen kullanıcının kendi sorumluluğundadır; oluşabilecek doğrudan veya dolaylı zararlardan Borsaya.com hiçbir şekilde sorumlu tutulamaz.',

  // About Page
  'about.pageTitle': 'Hakkımızda — Borsaya.com Nedir, Nasıl Çalışır',
  'about.title': 'Hakkımızda',
  'about.h1': 'Hakkımızda: Borsaya.com Nedir?',
  'about.desc': 'Borsaya.com\'un amacı, veri kaynakları ve yayın ilkeleri. 80\'den fazla küresel borsadan canlı fiyat sunan bağımsız finans veri platformunu tanıyın.',
  'about.whoTitle': 'Biz Kimiz?',
  'about.whoText': 'Borsaya.com, küresel finans piyasalarını herkes için erişilebilir kılmayı hedefleyen bağımsız bir finansal veri platformudur. 2026 yılında kurulan platformumuz, 80\'den fazla borsadan anlık ve gecikmeli piyasa verilerini tek bir çatı altında sunmaktadır.',
  'about.missionTitle': 'Misyonumuz',
  'about.missionText': 'Yatırımcıların doğru ve güncel veriye kolayca ulaşmasını sağlamak, piyasa analizini demokratikleştirmek ve finansal okuryazarlığa katkıda bulunmak temel misyonumuzdur. Karmaşık piyasa verilerini anlaşılır ve erişilebilir bir şekilde sunarak, bireysel yatırımcılardan profesyonellere kadar herkesin bilinçli kararlar almasına yardımcı oluyoruz.',
  'about.dataTitle': 'Veri Kaynakları',
  'about.dataText': 'Platformumuz; NYSE, NASDAQ, Xetra, Euronext, LSE, TSE ve daha birçok uluslararası borsadan veri toplamaktadır. Hisse senetleri, endeksler, döviz kurları, emtialar ve kripto paralar dahil olmak üzere geniş bir yelpazede finansal enstrümanları takip edebilirsiniz.',
  'about.dataItems': '7 bölgeden 82 borsa|Hisse senetleri, endeksler, döviz ve emtia verileri|CNBC, WSJ, BBC gibi kaynaklardan küresel haberler|Gerçek zamanlı ve gün sonu veri desteği',
  'about.valuesTitle': 'Değerlerimiz',
  'about.val1Title': 'Şeffaflık',
  'about.val1Text': 'Verilerimizin kaynağını ve gecikme sürelerini açıkça belirtiriz.',
  'about.val2Title': 'Erişilebilirlik',
  'about.val2Text': 'Piyasa verileri herkes için ücretsiz ve kolay erişilebilir olmalıdır.',
  'about.val3Title': 'Güvenilirlik',
  'about.val3Text': 'Doğru ve tutarlı veri sunmak en büyük önceliğimizdir.',
  'about.val4Title': 'Bağımsızlık',
  'about.val4Text': 'Hiçbir finansal kuruluştan bağımsız, tarafsız bir platform olarak hizmet veririz.',

  // Contact Page
  'contact.pageTitle': 'İletişim — Bize Ulaşın, Görüş Bildirin',
  'contact.title': 'İletişim',
  'contact.h1': 'İletişim ve Destek',
  'contact.reachText': 'Sorularınız, önerileriniz veya iş birliği talepleriniz için aşağıdaki kanallardan bize ulaşabilirsiniz.',
  'contact.email': 'E-posta',
  'contact.emailDesc': 'Genel sorular ve iş birlikleri için',
  'contact.social': 'Sosyal Medya',

  // Privacy Page
  'privacy.pageTitle': 'Gizlilik Politikası ve Çerez Aydınlatma Metni',
  'privacy.title': 'Gizlilik Politikası',
  'privacy.desc': 'Kişisel verilerinizin nasıl toplandığı, işlendiği ve korunduğu; kullanılan çerezler, Google Analytics ve Ads aktarımı ile KVKK kapsamındaki haklarınız.',
  'privacy.lastUpdate': 'Son güncelleme: Mart 2026',
  'privacy.introTitle': 'Giriş',
  'privacy.introText': 'Borsaya.com olarak kullanıcılarımızın gizliliğine büyük önem veriyoruz. Bu Gizlilik Politikası, platformumuzu kullanırken kişisel verilerinizin nasıl toplandığını, kullanıldığını ve korunduğunu açıklamaktadır.',
  'privacy.collectTitle': 'Toplanan Veriler',
  'privacy.collectText': 'Platformumuz aşağıdaki verileri toplayabilir:',
  'privacy.collectItems': 'Tarayıcı türü ve sürümü|IP adresi|Ziyaret edilen sayfalar ve kullanım süreleri|Tercih edilen dil ve tema ayarları|Çerezler aracılığıyla toplanan anonim kullanım verileri',
  'privacy.useTitle': 'Verilerin Kullanım Amaçları',
  'privacy.useText': 'Toplanan veriler aşağıdaki amaçlarla kullanılmaktadır:',
  'privacy.useItems': 'Platform deneyiminin iyileştirilmesi|İçerik ve özelliklerin kişiselleştirilmesi|Teknik sorunların tespit edilmesi ve giderilmesi|Anonim istatistiksel analizler|Yasal yükümlülüklerin yerine getirilmesi',
  'privacy.cookieTitle': 'Çerezler',
  'privacy.cookieText': 'Platformumuz iki tür çerez kullanır. (1) Zorunlu çerezler: tema tercihiniz (açık/koyu mod), dil seçiminiz ve çerez onay kaydınız (cookie_consent) — bunlar onay gerektirmez. (2) Onaya bağlı çerezler: yalnızca siz \'Kabul Et\' dedikten sonra yüklenir. Bunlar Google Analytics 4 (_ga, _gid — kullanım istatistiği) ve Google Ads (_gcl_* — reklam ölçümü ve kişiselleştirme) çerezleridir. Onay vermezseniz veya reddederseniz bu çerezler yüklenmez ve mevcut olanlar silinir. Kararınızı istediğiniz zaman sayfa altındaki \'Çerez Tercihleri\' bağlantısından değiştirebilirsiniz.',
  'privacy.thirdTitle': 'Üçüncü Taraflar',
  'privacy.thirdText': 'Kişisel verilerinizi satmıyoruz. Ancak açık rızanız olduğunda, platformumuzda kullanılan Google hizmetleri (Google Analytics 4 ve Google Ads) aracılığıyla kullanım ve reklam ölçüm verileri Google LLC ile paylaşılır; bu veriler reklam ölçümü ve kişiselleştirme amacıyla da işlenebilir. Google Consent Mode v2 kullandığımız için onay vermediğinizde bu aktarım gerçekleşmez. Google\'ın veri işleme politikası: policies.google.com/privacy',
  'privacy.rightsTitle': 'Haklarınız',
  'privacy.rightsText': 'KVKK (6698 sayılı Kişisel Verilerin Korunması Kanunu) kapsamında aşağıdaki haklara sahipsiniz:',
  'privacy.rightsItems': 'Kişisel verilerinizin işlenip işlenmediğini öğrenme|Kişisel verileriniz işlenmişse buna ilişkin bilgi talep etme|Kişisel verilerinizin işlenme amacını öğrenme|Kişisel verilerinizin silinmesini veya yok edilmesini isteme',
  'privacy.contactTitle': 'İletişim',
  'privacy.contactText': 'Gizlilik politikamız hakkında sorularınız için support@borsaya.com adresinden bize ulaşabilirsiniz.',

  // Terms Page
  'terms.pageTitle': 'Kullanım Koşulları ve Yasal Sorumluluk Reddi',
  'terms.title': 'Kullanım Koşulları',
  'terms.desc': 'Borsaya.com\'u kullanmadan önce okumanız gereken koşullar: içerik kullanımı, veri doğruluğu, sorumluluk sınırları ve yatırım tavsiyesi feragatnamesi.',
  'terms.lastUpdate': 'Son güncelleme: Mart 2026',
  'terms.generalTitle': 'Genel Koşullar',
  'terms.generalText': 'Borsaya.com platformunu kullanarak aşağıdaki koşulları kabul etmiş sayılırsınız. Bu koşullar, platform ile kullanıcı arasındaki ilişkiyi düzenler ve platformun tüm hizmetlerini kapsar.',
  'terms.disclaimerTitle': 'Sorumluluk Reddi',
  'terms.disclaimerText': 'Borsaya.com bir yatırım danışmanlık hizmeti değildir. Platformda sunulan tüm veriler, haberler ve analizler yalnızca bilgilendirme amaçlıdır ve yatırım tavsiyesi niteliği taşımaz. Yatırım kararlarınızdan doğabilecek her türlü kayıp ve zarardan yalnızca siz sorumlusunuz.',
  'terms.disclaimerItems': 'Piyasa verileri gecikmeli olabilir ve gerçek zamanlı fiyatları yansıtmayabilir|Haberler ve analizler üçüncü taraf kaynaklardan derlenmiştir|Platform, veri doğruluğu konusunda garanti vermez|Yatırım kararlarınızı almadan önce lisanslı bir danışmana başvurmanız önerilir',
  'terms.dataTitle': 'Veri Kullanımı',
  'terms.dataText': 'Platformda yer alan tüm veriler kişisel kullanım içindir. Verilerin ticari amaçla kopyalanması, dağıtılması veya yeniden yayınlanması yasaktır. Veri sağlayıcılarımızın lisans koşullarına tabidir.',
  'terms.ipTitle': 'Fikri Mülkiyet',
  'terms.ipText': 'Borsaya.com\'un tasarımı, logosu, içerikleri ve yazılımı fikri mülkiyet hakları ile korunmaktadır. İzinsiz kullanım, kopyalama veya dağıtım yasaktır.',
  'terms.changeTitle': 'Değişiklikler',
  'terms.changeText': 'Borsaya.com, bu kullanım koşullarını önceden bildirimde bulunmaksızın değiştirme hakkını saklı tutar. Güncel koşullar her zaman bu sayfadan erişilebilir olacaktır. Platformu kullanmaya devam etmeniz, değişiklikleri kabul ettiğiniz anlamına gelir.',
  'terms.contactTitle': 'İletişim',
  'terms.contactText': 'Kullanım koşulları hakkında sorularınız için support@borsaya.com adresinden bize ulaşabilirsiniz.',

  // Exchange Detail
  'exchange.title': 'Borsa Detayı',
  'exchange.indices': 'Endeksler',
  'exchange.stocks': 'Hisseler',
  'exchange.tradingHours': 'İşlem Saatleri',
  'exchange.tradingDays': 'İşlem Günleri',
  'exchange.timezone': 'Saat Dilimi',
  'exchange.currency': 'Para Birimi',
  'exchange.dataAccess': 'Veri Seviyesi',
  'exchange.noIndices': 'Bu borsada endeks verisi bulunamadı.',
  'exchange.noStocks': 'Bu borsada hisse verisi bulunamadı.',
  'exchange.notFound': 'Borsa bulunamadı',
  'exchange.notFoundDesc': 'Aradığınız borsa mevcut değil veya aktif değil.',
  'exchange.exchanges': 'Borsalar',

  // CryptoListPage
  'crypto.title': 'Kripto Para Fiyatları',
  'crypto.pageTitle': 'Kripto Para Fiyatları — Canlı Piyasa Verileri',
  'crypto.desc': 'Bitcoin, Ethereum ve yüzlerce kripto paranın canlı fiyatı, 24 saatlik değişimi ve piyasa değeri. Grafiklerle kripto piyasasını anlık takip edin.',
  'crypto.topGainer': 'En Çok Yükselen',
  'crypto.topLoser': 'En Çok Düşen',
  'crypto.largestCap': 'En Yüksek Piyasa Değeri',
  'crypto.searchPlaceholder': 'Kripto ara...',
  'crypto.listed': 'kripto listeleniyor',
  'crypto.24hChange': '24s Değişim',
  'crypto.marketCap': 'Piyasa Değeri',
  'crypto.volume': 'Hacim (24s)',
  'crypto.coin': 'Coin',
  'crypto.price': 'Fiyat',

  // SEO
  'seo.homeTitle': 'Canlı Borsa, Döviz ve Kripto Fiyatları',
  'seo.homeDesc': '80\'den fazla borsadan canlı hisse senedi, döviz, kripto ve emtia fiyatlarını takip edin. Anlık grafikler, piyasa verileri ve son dakika finans haberleri.',
  'seo.newsListTitle': 'Finans ve Piyasa Haberleri — Son Dakika',
  'seo.newsListDesc': 'Küresel borsalardan son dakika finans haberleri, piyasa analizleri, şirket bilançoları ve ekonomi gündemi. Günlük güncellenen tarafsız haber akışı.',

  // ── Haber kategorisi sayfaları (her biri AYRI başlık/açıklama) ──
  // Kategoriler artık query filtresi değil, kendi canonical'ı olan gerçek sayfalar.
  // Bu yüzden meta başlık ve açıklamaları da birbirinin kopyası OLMAMALIDIR.
  'seo.newsCat.piyasalar.title': 'Piyasa Haberleri — Borsa ve Endeks Gündemi',
  'seo.newsCat.piyasalar.desc': 'Küresel borsalardan güncel piyasa haberleri: endeks hareketleri, seans özetleri, hisse senedi gündemi ve yatırımcıları ilgilendiren gelişmeler.',
  'seo.newsCat.ekonomi.title': 'Ekonomi Haberleri — Faiz, Enflasyon ve Büyüme',
  'seo.newsCat.ekonomi.desc': 'Merkez bankası kararları, faiz ve enflasyon verileri, büyüme rakamları ve makroekonomik göstergelere dair güncel ekonomi haberleri.',
  'seo.newsCat.bilancolar.title': 'Bilanço Haberleri — Şirket Finansal Sonuçları',
  'seo.newsCat.bilancolar.desc': 'Halka açık şirketlerin çeyreklik ve yıllık bilançoları, kâr-zarar açıklamaları, gelir beklentileri ve finansal sonuç değerlendirmeleri.',
  'seo.newsCat.dunya.title': 'Dünya Haberleri — Küresel Ekonomi ve Siyaset',
  'seo.newsCat.dunya.desc': 'Küresel ekonomiyi ve piyasaları etkileyen dünya gündemi: jeopolitik gelişmeler, ticaret politikaları ve uluslararası ekonomik kararlar.',
  'seo.newsCat.enerji.title': 'Enerji Haberleri — Petrol, Doğal Gaz ve Elektrik',
  'seo.newsCat.enerji.desc': 'Brent ve WTI petrol fiyatları, doğal gaz piyasası, OPEC kararları, elektrik ve yenilenebilir enerji sektöründen güncel haberler.',
  'seo.newsCat.teknoloji.title': 'Teknoloji Haberleri — Teknoloji Hisseleri ve Yapay Zeka',
  'seo.newsCat.teknoloji.desc': 'Teknoloji şirketleri, yapay zeka yatırımları, yarı iletken sektörü ve Nasdaq teknoloji hisselerini etkileyen güncel gelişmeler.',
  'seo.newsCat.kripto.title': 'Kripto Para Haberleri — Bitcoin ve Altcoin Gündemi',
  'seo.newsCat.kripto.desc': 'Bitcoin, Ethereum ve altcoin piyasasından son dakika kripto para haberleri, regülasyon gelişmeleri ve blokzincir sektörü gündemi.',
  'seo.newsCat.forex-emtia.title': 'Döviz ve Emtia Haberleri — Parite, Altın, Petrol',
  'seo.newsCat.forex-emtia.desc': 'Dolar, euro ve sterlin pariteleri, altın ve gümüş fiyatları, tarımsal ve endüstriyel emtia piyasalarından güncel haberler.',
  'seo.newsCat.rehber.title': 'Yatırım Rehberi Haberleri — Eğitim ve İpuçları',
  'seo.newsCat.rehber.desc': 'Yeni başlayanlar ve deneyimli yatırımcılar için yatırım rehberi içerikleri: strateji, risk yönetimi ve piyasa terimlerine dair açıklayıcı haberler.',
  'news.categoryBreadcrumb': 'Kategori',
  'news.backToAll': 'Tüm haberlere dön',
  'seo.guidesTitle': 'Yatırım Rehberleri — Borsa, Kripto ve Döviz',
  'seo.guidesDesc': 'Borsa, kripto, döviz ve emtia piyasaları için kapsamlı rehberler. Yeni başlayanlardan ileri düzeye tüm yatırımcılar için.',
  'seo.stockTitle': '{symbol} Hisse Senedi — Canlı Fiyat ve Grafik',
  'seo.stockDesc': '{symbol} hisse senedi canlı fiyatı, günlük değişimi, işlem hacmi ve geçmiş grafiği. Açılış, en yüksek ve en düşük seviyelerle güncel piyasa verileri.',
  'seo.indexDesc': '{name} endeksi canlı fiyat, grafik ve bileşen hisseleri.',
  'seo.cryptoDesc': '{name} ({symbol}) canlı fiyatı, piyasa değeri, dolaşımdaki arz ve 24 saatlik değişim grafiği. Kripto para piyasasından güncel veriler.',
  'seo.forexDesc': '{pair} döviz kuru canlı fiyat ve grafik.',
  'seo.exchangeDesc': '{name} borsası endeksler, hisseler ve işlem saatleri.',
  'seo.contactDesc': 'Borsaya.com iletişim bilgileri, destek ve iş birliği kanalları. Soru, öneri ve hata bildirimleriniz için bize doğrudan ulaşabilirsiniz.',

  // Guides
  'guides.title': 'Yatırım Rehberleri',
  'guides.desc': 'Borsa, kripto, döviz ve emtia piyasaları için kapsamlı rehberler.',
  'guides.readMore': 'Devamını Oku',
  'guides.empty': 'Henüz rehber içeriği bulunmuyor.',

  // Instrument About
  'instrument.aboutTitle': 'Hakkında:',
  'instrument.faqTitle': 'Sık Sorulan Sorular',

  // Homepage SEO content
  // T5 (Temmuz 2026 denetimi): H1, title/description'daki hedef kelimeleri (borsa,
  // döviz, kripto) taşımıyordu — kelime kökü paylaşımı için başa eklendi.
  'home.introTitle': 'Canlı Borsa, Döviz ve Kripto Fiyatları: Küresel Piyasalar Tek Platformda',
  'home.introP1': 'Borsaya.com, dünya genelindeki 80\'den fazla borsadan anlık ve gecikmeli piyasa verilerini tek çatı altında sunan bağımsız bir finans platformudur. New York Borsası (NYSE), NASDAQ, Xetra, Euronext, Londra Borsası (LSE), Tokyo Borsası (TSE) ve daha birçok uluslararası borsadan hisse senedi fiyatlarını, endeks değerlerini ve piyasa istatistiklerini takip edebilirsiniz.',
  'home.introP2': 'Döviz kurları, kripto para fiyatları, emtia verileri ve güncel finans haberleriyle yatırım kararlarınız için ihtiyaç duyduğunuz tüm bilgilere hızlıca ulaşın. S&P 500, Dow Jones, DAX, FTSE 100, Nikkei 225 gibi önemli endekslerin günlük performanslarını detaylı grafiklerle analiz edin.',
  'home.introP3': 'Altın, petrol, gümüş gibi emtia fiyatları; USD/TRY, EUR/USD, GBP/USD gibi döviz çiftleri; Bitcoin, Ethereum gibi kripto paralar — tüm finansal enstrümanları tek platformdan izleyin. Son dakika piyasa haberleri ve ekonomi gündemine dair gelişmeleri kaçırmayın.',
  'home.marketsTitle': 'Küresel Endeksler ve Hisse Senetleri',
  'home.marketsP1': 'ABD\'den Dow Jones Industrial Average, S&P 500, NASDAQ Composite, Avrupa\'dan DAX 40, FTSE 100, CAC 40, Euro Stoxx 50, Asya\'dan Nikkei 225, Hang Seng, Shanghai Composite, KOSPI ve daha fazlası — dünyanın dört bir yanından önemli borsa endekslerini gerçek zamanlı olarak takip edin. Her endeks için günlük, haftalık, aylık ve yıllık performans değişimlerini karşılaştırın.',
  'home.marketsP2': 'Hisse senedi yatırımcıları için detaylı grafik ve teknik analiz araçları sunuyoruz. Apple, Microsoft, Tesla, Amazon, Nvidia, Google gibi küresel hisselerden binlerce hissenin anlık fiyatını, işlem hacmini ve piyasa değerini görüntüleyin.',
  'home.forexTitle': 'Döviz Kurları ve Kripto Paralar',
  'home.forexP1': 'Dolar/TL, Euro/TL, Sterlin/TL başta olmak üzere tüm önemli döviz çiftlerinin anlık kurlarını izleyin. Ayrıca Bitcoin (BTC), Ethereum (ETH), Solana (SOL), Binance Coin (BNB), Ripple (XRP), Cardano (ADA) ve Dogecoin (DOGE) gibi popüler kripto paraların güncel fiyatlarını, piyasa değerlerini ve 24 saatlik değişim oranlarını karşılaştırın.',
  'home.forexP2': 'Emtia piyasalarında altın (XAU/USD), ham petrol (Brent Crude), gümüş, bakır ve doğal gaz fiyatlarını anlık olarak takip edin. Küresel ekonomik gelişmelerin emtia fiyatlarına etkisini anlık verilerle analiz edin. Platformumuz, 7 farklı bölgeden 82 borsanın verilerini bir araya getirerek yatırımcılara kapsamlı bir piyasa görünümü sunar.',

  // Cookie Consent
  'cookie.title': 'Çerez Kullanımı',
  'cookie.text': 'Deneyiminizi iyileştirmek ve site trafiğini analiz etmek için çerezler kullanıyoruz. IP adresi, konum ve kullanım verileri toplanabilir.',
  'cookie.accept': 'Kabul Et',
  'cookie.reject': 'Reddet',
  'cookie.privacy': 'Gizlilik Politikası',

  // Accessibility (aria-labels)
  'aria.prevTicker': 'Önceki gösterge',
  'aria.nextTicker': 'Sonraki gösterge',
  'aria.prevNews': 'Önceki haber',
  'aria.nextNews': 'Sonraki haber',
  'aria.toggleTheme': 'Temayı değiştir',
  'aria.search': 'Ara',
  'aria.closeSearch': 'Aramayı kapat',
  'aria.clearSearch': 'Aramayı temizle',
  'aria.moreOptions': 'Daha fazla seçenek',
  'aria.darkMode': 'Karanlık moda geç',
  'aria.lightMode': 'Aydınlık moda geç',
}

const en: Record<string, string> = {
  // Navigation
  'nav.markets': 'Markets',
  'nav.stocks': 'Stocks',
  'nav.crypto': 'Crypto',
  'nav.news': 'News',
  'nav.brokers': 'Brokers',
  'nav.home': 'Home',
  'nav.search': 'Search',
  'nav.guides': 'Guides',

  // GlobalMarkets regions
  'region.us': 'US Markets',
  'region.eu': 'European Markets',
  'region.apac': 'Asia-Pacific Markets',
  'region.americas': 'Americas',
  'region.mea': 'Middle East & Africa',

  // Table headers
  'th.exchange': 'Exchange',
  'th.last': 'Last',
  'th.percent': '%',
  'th.change': 'Change',
  'th.monthly': 'Monthly(%)',
  'th.yearly': 'Yearly(%)',
  'th.name': 'Name',
  'th.lastPrice': 'Last Price',
  'th.changePercent': 'Change %',
  'th.volume': 'Vol.',
  'th.stock': 'Stock',
  'th.price': 'Price',
  'th.low': 'Low',
  'th.high': 'High',
  'th.marketCap': 'Market Cap',
  'th.institution': 'Institution',

  // Sidebar
  'sidebar.markets': 'Markets',
  'sidebar.brokers': 'Brokers',
  'sidebar.indices': 'Indices',
  'sidebar.forex': 'Currencies',
  'sidebar.commodities': 'Commodities',
  'sidebar.stocks': 'Stocks',
  'sidebar.movers': 'Market Movers',
  'sidebar.active': 'Most Active',
  'sidebar.gainers': 'Top Gainers %',
  'sidebar.losers': 'Top Losers %',
  'sidebar.leading': 'Leading Stocks',
  'sidebar.latestNews': 'Latest News',
  'sidebar.showMore': 'Show more',
  'sidebar.platforms': 'Investment Platforms',
  'sidebar.platformsDesc': 'Leading Turkish brokers and commission rates.',
  'sidebar.viewAll': 'View all platforms',
  'sidebar.disclaimer': 'Commission rates are for informational purposes. Visit the relevant institution\'s website for current conditions.',

  // FeaturedNews
  'featured.breaking': 'Breaking News',
  'featured.viewAll': 'View All News →',

  // SearchBar
  'search.placeholder': 'Search stocks, currencies, crypto...',
  'search.popular': 'Popular Searches',
  'search.searching': 'Searching...',
  'search.noResults': 'No results found',
  'search.cancel': 'Cancel',

  // SearchBar categories
  'cat.index': 'Index',
  'cat.bist': 'Türkiye',
  'cat.us': 'US',
  'cat.eu': 'Europe',
  'cat.japan': 'Japan',
  'cat.hkchina': 'HK/China',
  'cat.korea': 'Korea',
  'cat.india': 'India',
  'cat.forex': 'Currencies',
  'cat.crypto': 'Crypto',
  'cat.commodity': 'Commodity',

  // TickerBar
  'ticker.gold': 'Gold',
  'live': 'LIVE',

  // Periods
  'period.daily': 'Daily',
  'period.weekly': 'Weekly',
  'period.monthly': 'Monthly',
  'period.yearly': 'Yearly',
  'period.5year': '5 Year',

  // Status messages
  'status.loading': 'Loading...',
  'status.loadingData': 'Loading data...',
  'status.loadingChart': 'Loading chart...',
  'status.loadingNews': 'Loading news...',
  'status.loadingMarket': 'Loading market data...',
  'status.noData': 'No index data found',
  'status.noResults': 'No search results found',

  // News categories
  'news.all': 'All',
  'news.markets': 'Markets',
  'news.economy': 'Economy',
  'news.earnings': 'Earnings',
  'news.world': 'World',
  'news.energy': 'Energy',
  'news.tech': 'Technology',
  'news.crypto': 'Crypto',
  'news.byline': 'Borsaya Newsroom',
  'news.dataDelay': 'Price data is for information only and may be delayed. It is not investment advice.',
  'news.forexCommodity': 'Currencies & Commodities',
  'news.guide': 'Guide',

  // News page
  'news.title': 'Financial and Market News',
  'news.desc': 'Breaking news and analysis from global financial markets.',
  'news.item': 'news',
  'news.notFound': 'No news found',
  'news.emptyCategory': 'No news in this category yet.',
  'news.searchPlaceholder': 'Search news...',
  'news.searchResults': '{count} news found',
  'news.clearSearch': 'Clear search',
  'news.prev': '← Previous',
  'news.next': 'Next →',

  // NewsDetail
  'detail.notFound': 'Article not found',
  'detail.notFoundDesc': 'The article you are looking for does not exist or has been removed.',
  'detail.backHome': 'Back to Home',
  'detail.readMin': 'min read',
  'detail.relatedNews': 'Related News',
  'detail.noRelated': 'No related news yet.',
  'detail.viewAll': 'View All News →',
  'detail.share': 'Share',
  'detail.copyLink': 'Copy Link',
  'detail.copied': 'Copied!',
  'detail.comments': 'Comments',
  'detail.writeComment': 'Write a comment...',
  'detail.reply': 'Reply',
  'detail.showMoreComments': 'Show more comments',
  'detail.firstName': 'First Name',
  'detail.lastName': 'Last Name',
  'detail.email': 'Email',
  'detail.submitComment': 'Submit Comment',
  'detail.noComments': 'No comments yet. Be the first to comment!',
  'detail.commentSuccess': 'Your comment has been added!',
  'detail.report': 'Report',
  'detail.reportSpam': 'Spam',
  'detail.reportOffensive': 'Offensive Language',
  'detail.reportMisleading': 'Misleading Information',
  'detail.reportAd': 'Advertisement',
  'detail.reportOther': 'Other',
  'detail.reported': 'Reported',
  'detail.alreadyReported': 'You already reported this comment',
  'detail.listen': 'Listen',
  'detail.listening': 'Listening...',
  'detail.pause': 'Pause',
  'detail.resume': 'Resume',
  'detail.stop': 'Stop',
  'detail.relatedSymbols': 'Related Symbols',

  // Time
  'time.justNow': 'Just now',
  'time.minsAgo': 'm ago',
  'time.hoursAgo': 'h ago',
  'time.daysAgo': 'd ago',

  // StocksPage
  'stocks.title': 'Global Stocks',
  'stocks.pageTitle': 'Global Stocks — Live Prices and Charts',
  'stocks.desc': 'Track stock prices from US, European and Asian exchanges live. Daily change, trading volume, monthly and yearly performance on a single screen.',
  'stocks.topGainers': 'Top Gainers',
  'stocks.topLosers': 'Top Losers',
  'stocks.mostActive': 'Most Active',
  'stocks.searchPlaceholder': 'Search stocks...',
  'stocks.listed': 'stocks listed',
  'stocks.all': 'All',
  'stocks.asia': 'Asia',
  'stocks.bank': 'Banking',
  'stocks.industry': 'Industry',
  'stocks.services': 'Services',
  'stocks.japan': 'Japan',
  'stocks.southKorea': 'South Korea',
  'stocks.india': 'India',
  'stocks.china': 'China',
  'stocks.taiwan': 'Taiwan',
  'stocks.indonesia': 'Indonesia',
  'stocks.australia': 'Australia',
  'stocks.americas': 'Other Americas',
  'stocks.mea': 'Middle East & Africa',
  'stocks.canada': 'Canada',
  'stocks.brazil': 'Brazil',
  'stocks.saudiArabia': 'Saudi Arabia',

  // BrokersPage
  'brokers.title': 'Brokers',
  'brokers.h1': 'Stock Broker and Commission Comparison',
  'brokers.pageTitle': 'Stock Brokers — Commission Comparison',
  'brokers.desc': 'Compare commission rates, platform features and available instruments across brokers. Find the one that fits the way you actually invest.',
  'brokers.platforms': 'Investment Platforms',
  'brokers.commission': 'Commission Comparison',
  'brokers.zeroComm': 'Zero Commission',
  'brokers.disclaimer': 'Commission rates are for informational purposes and may be changed by institutions. Visit the relevant broker\'s website for current rates and conditions. Borsaya.com does not provide investment advice.',

  // Broker descriptions
  'brokers.midas': 'Zero-commission domestic investment platform. Access Turkish, US and European stocks from a single app.',
  'brokers.garanti': 'Full-service brokerage under Garanti BBVA. Mobile trading with Garanti Yatırım Trader app.',
  'brokers.is': 'Turkey\'s largest brokerage firm. Fast orders, analysis and portfolio management with İşTeFon app.',
  'brokers.ak': 'Akbank group brokerage. Advanced charting and analysis tools with TradeAll platform.',
  'brokers.yapikredi': 'Yapı Kredi Bank\'s investment arm. Established brokerage for equities, futures and international markets.',
  'brokers.deniz': 'DenizBank\'s investment arm. Stock trading, futures and investment advisory services.',
  'brokers.teb': 'TEB (Turkish Economy Bank)\'s investment arm. Brokerage services in equities and futures markets.',
  'brokers.ziraat': 'Ziraat Bank\'s investment arm. Serving individual and institutional investors through an extensive branch network.',
  'brokers.vakif': 'Vakıfbank\'s investment arm. Wide range of products including stocks, bonds, funds and futures.',
  'brokers.halk': 'Halkbank\'s investment arm. Serving retail investors through 1,000+ bank branches.',
  'brokers.qnb': 'QNB Finansbank\'s investment arm. Equities, futures and international markets.',
  'brokers.oyak': 'Brokerage under the OYAK (Military Pension Fund) group. Wide range of equities and futures services.',
  'brokers.gedik': 'Independent SPK-licensed brokerage. Equities, VIOP, international markets and investment advisory.',
  'brokers.tera': 'Serving individual and institutional investors in equities, VIOP and advisory since 1990.',
  'brokers.gcm': 'Technology-driven online investment platform specializing in VIOP and equities.',
  'brokers.unlu': 'ÜNLÜ & Co\'s investment arm. Equities, warrants, international markets and corporate finance.',
  'brokers.tacirler': 'Established brokerage since 1991. Stock trading, portfolio management and investment advisory.',
  'brokers.integral': 'SPK-licensed brokerage offering equities, IPO intermediation and corporate finance services.',
  'brokers.info': 'Under Hedef Holding since 1994. Live market data and analysis for retail and institutional clients.',
  'brokers.seker': 'Şekerbank affiliate since 1996. Wide range of investment products for retail and institutional investors.',
  'brokers.global': 'Over 30 years of experience since 1990. Stock trading, futures and portfolio management.',
  'brokers.alb': 'Rebranded from ALB Yatırım to Pusula Yatırım. Equities and futures brokerage services.',
  'brokers.ahlatci': 'Under Ahlatçı Holding. Fast and reliable trading infrastructure for retail investors.',
  'brokers.piramit': 'Independent brokerage since 1991. Focused on retail investors in equities and VIOP.',
  'brokers.inter': 'Istanbul-based SPK-licensed brokerage. Intermediation in equities and capital markets.',
  'brokers.burgan': 'Burgan Bank affiliate. Brokerage, corporate finance and asset management for retail and institutions.',
  'brokers.hedef': 'Licensed investment bank under Hedef Holding, focused on investment banking activities.',

  // Footer
  'footer.desc': 'Stock prices, exchange rates, crypto data, market news and financial analysis from Nasdaq, S&P 500, DAX and 80+ global exchanges. Your global financial data hub.',
  'footer.markets': 'Markets',
  'footer.explore': 'Explore',
  'footer.info': 'Info',
  'footer.gold': 'Gold',
  'footer.dollarTl': 'Dollar/TL',
  'footer.about': 'About Us',
  'footer.contact': 'Contact',
  'footer.privacy': 'Privacy Policy',
  'footer.terms': 'Terms of Use',
  'footer.cookieSettings': 'Cookie Preferences',
  'footer.copyright': '© 2026 Borsaya.com — All rights reserved.',
  'footer.disclaimer': 'Borsaya.com is not an investment advisory firm and does not provide investment advisory services. All data, news, analyses and content on this platform are provided for general informational purposes only and do not constitute a recommendation to buy or sell any security or investment advice of any kind. Investment decisions are entirely the responsibility of the user; Borsaya.com cannot be held liable for any direct or indirect losses that may occur. It is recommended that you conduct your own research and consult a licensed investment advisor when necessary before making any investment.',

  // About Page
  'about.pageTitle': 'About — What Borsaya.com Is and How It Works',
  'about.title': 'About Us',
  'about.h1': 'About Borsaya.com: Who We Are',
  'about.desc': 'Learn about Borsaya.com\'s mission, data sources and editorial principles — an independent platform serving live prices from 80+ global exchanges.',
  'about.whoTitle': 'Who We Are',
  'about.whoText': 'Borsaya.com is an independent financial data platform that aims to make global financial markets accessible to everyone. Founded in 2026, our platform aggregates real-time and delayed market data from over 80 exchanges under one roof.',
  'about.missionTitle': 'Our Mission',
  'about.missionText': 'Our core mission is to enable investors to easily access accurate and up-to-date data, democratize market analysis, and contribute to financial literacy. By presenting complex market data in an understandable and accessible way, we help everyone from individual investors to professionals make informed decisions.',
  'about.dataTitle': 'Data Sources',
  'about.dataText': 'Our platform collects data from NYSE, NASDAQ, Xetra, Euronext, LSE, TSE and many other international exchanges. You can track a wide range of financial instruments including stocks, indices, currency exchange rates, commodities and cryptocurrencies.',
  'about.dataItems': '82 exchanges across 7 regions|Stocks, indices, currencies and commodity data|Global news from sources like CNBC, WSJ, BBC|Real-time and end-of-day data support',
  'about.valuesTitle': 'Our Values',
  'about.val1Title': 'Transparency',
  'about.val1Text': 'We clearly state the source and delay times of our data.',
  'about.val2Title': 'Accessibility',
  'about.val2Text': 'Market data should be free and easily accessible to everyone.',
  'about.val3Title': 'Reliability',
  'about.val3Text': 'Providing accurate and consistent data is our top priority.',
  'about.val4Title': 'Independence',
  'about.val4Text': 'We serve as an unbiased platform, independent of any financial institution.',

  // Contact Page
  'contact.pageTitle': 'Contact — Get in Touch and Send Feedback',
  'contact.title': 'Contact',
  'contact.h1': 'Contact and Support',
  'contact.reachText': 'You can reach us through the channels below for your questions, suggestions or partnership inquiries.',
  'contact.email': 'Email',
  'contact.emailDesc': 'For general inquiries and partnerships',
  'contact.social': 'Social Media',

  // Privacy Page
  'privacy.pageTitle': 'Privacy Policy and Cookie Disclosure Notice',
  'privacy.title': 'Privacy Policy',
  'privacy.desc': 'How your personal data is collected, processed and protected; the cookies we use, transfers to Google Analytics and Ads, and your data rights.',
  'privacy.lastUpdate': 'Last updated: March 2026',
  'privacy.introTitle': 'Introduction',
  'privacy.introText': 'At Borsaya.com, we take the privacy of our users very seriously. This Privacy Policy explains how your personal data is collected, used and protected when using our platform.',
  'privacy.collectTitle': 'Data We Collect',
  'privacy.collectText': 'Our platform may collect the following data:',
  'privacy.collectItems': 'Browser type and version|IP address|Pages visited and usage duration|Preferred language and theme settings|Anonymous usage data collected through cookies',
  'privacy.useTitle': 'How We Use Data',
  'privacy.useText': 'Collected data is used for the following purposes:',
  'privacy.useItems': 'Improving the platform experience|Personalizing content and features|Identifying and resolving technical issues|Anonymous statistical analysis|Fulfilling legal obligations',
  'privacy.cookieTitle': 'Cookies',
  'privacy.cookieText': 'Our platform uses two kinds of cookies. (1) Essential cookies: your theme preference (light/dark mode), language selection and your consent record (cookie_consent) — these require no consent. (2) Consent-based cookies: loaded only after you choose \'Accept\'. These are Google Analytics 4 (_ga, _gid — usage statistics) and Google Ads (_gcl_* — ad measurement and personalisation). If you decline, these cookies are not loaded and any existing ones are deleted. You can change your decision at any time via the \'Cookie Preferences\' link in the footer.',
  'privacy.thirdTitle': 'Third Parties',
  'privacy.thirdText': 'We do not sell your personal data. However, with your explicit consent, usage and ad measurement data is shared with Google LLC through the Google services we use (Google Analytics 4 and Google Ads), and may also be processed for ad measurement and personalisation. Because we use Google Consent Mode v2, no such transfer happens if you do not consent. Google\'s privacy policy: policies.google.com/privacy',
  'privacy.rightsTitle': 'Your Rights',
  'privacy.rightsText': 'Under applicable data protection regulations, you have the following rights:',
  'privacy.rightsItems': 'To learn whether your personal data is being processed|To request information about processed personal data|To learn the purpose of personal data processing|To request deletion or destruction of your personal data',
  'privacy.contactTitle': 'Contact',
  'privacy.contactText': 'For questions about our privacy policy, you can reach us at support@borsaya.com.',

  // Terms Page
  'terms.pageTitle': 'Terms of Use and Investment Disclaimer',
  'terms.title': 'Terms of Use',
  'terms.desc': 'What to read before using Borsaya.com: content use, data accuracy, limits of liability and our investment advice disclaimer explained in full.',
  'terms.lastUpdate': 'Last updated: March 2026',
  'terms.generalTitle': 'General Terms',
  'terms.generalText': 'By using the Borsaya.com platform, you agree to the following terms. These terms govern the relationship between the platform and the user and cover all services of the platform.',
  'terms.disclaimerTitle': 'Disclaimer',
  'terms.disclaimerText': 'Borsaya.com is not an investment advisory service. All data, news and analyses presented on the platform are for informational purposes only and do not constitute investment advice. You are solely responsible for any losses that may arise from your investment decisions.',
  'terms.disclaimerItems': 'Market data may be delayed and may not reflect real-time prices|News and analyses are compiled from third-party sources|The platform does not guarantee data accuracy|It is recommended to consult a licensed advisor before making investment decisions',
  'terms.dataTitle': 'Data Usage',
  'terms.dataText': 'All data on the platform is for personal use only. Commercial copying, distribution or republication of data is prohibited. Data is subject to the licensing terms of our data providers.',
  'terms.ipTitle': 'Intellectual Property',
  'terms.ipText': 'The design, logo, content and software of Borsaya.com are protected by intellectual property rights. Unauthorized use, copying or distribution is prohibited.',
  'terms.changeTitle': 'Changes',
  'terms.changeText': 'Borsaya.com reserves the right to change these terms of use without prior notice. Current terms will always be accessible from this page. Continuing to use the platform means you accept the changes.',
  'terms.contactTitle': 'Contact',
  'terms.contactText': 'For questions about terms of use, you can reach us at support@borsaya.com.',

  // Exchange Detail
  'exchange.title': 'Exchange Detail',
  'exchange.indices': 'Indices',
  'exchange.stocks': 'Stocks',
  'exchange.tradingHours': 'Trading Hours',
  'exchange.tradingDays': 'Trading Days',
  'exchange.timezone': 'Timezone',
  'exchange.currency': 'Currency',
  'exchange.dataAccess': 'Data Access',
  'exchange.noIndices': 'No index data found for this exchange.',
  'exchange.noStocks': 'No stock data found for this exchange.',
  'exchange.notFound': 'Exchange not found',
  'exchange.notFoundDesc': 'The exchange you are looking for does not exist or is inactive.',
  'exchange.exchanges': 'Exchanges',

  // CryptoListPage
  'crypto.title': 'Cryptocurrency Prices',
  'crypto.pageTitle': 'Cryptocurrency Prices — Live Market Data',
  'crypto.desc': 'Live prices, 24-hour change and market cap for Bitcoin, Ethereum and hundreds of cryptocurrencies. Follow the crypto market in real time.',
  'crypto.topGainer': 'Top Gainer',
  'crypto.topLoser': 'Top Loser',
  'crypto.largestCap': 'Largest Market Cap',
  'crypto.searchPlaceholder': 'Search crypto...',
  'crypto.listed': 'crypto listed',
  'crypto.24hChange': '24h Change',
  'crypto.marketCap': 'Market Cap',
  'crypto.volume': 'Volume (24h)',
  'crypto.coin': 'Coin',
  'crypto.price': 'Price',

  // SEO
  'seo.homeTitle': 'Live Stock, Exchange Rates & Crypto Prices',
  'seo.homeDesc': 'Track live stock indices, exchange rates, crypto and commodity prices from 80+ global exchanges. Get real-time charts, market data and breaking financial news.',
  'seo.newsListTitle': 'Financial and Market News — Breaking Updates',
  'seo.newsListDesc': 'Breaking financial news from global exchanges, market analysis, company earnings and the economic agenda. An impartial news feed updated daily.',

  // ── News category pages (each with its OWN title/description) ──
  'seo.newsCat.piyasalar.title': 'Market News — Stock Market and Index Coverage',
  'seo.newsCat.piyasalar.desc': 'Current market news from global exchanges: index moves, session summaries, equity coverage and the developments that matter to investors.',
  'seo.newsCat.ekonomi.title': 'Economy News — Rates, Inflation and Growth',
  'seo.newsCat.ekonomi.desc': 'Central bank decisions, interest rate and inflation data, growth figures and macroeconomic indicators explained in up-to-date economy news.',
  'seo.newsCat.bilancolar.title': 'Earnings News — Company Financial Results',
  'seo.newsCat.bilancolar.desc': 'Quarterly and annual earnings from publicly listed companies, profit and loss announcements, revenue guidance and results analysis.',
  'seo.newsCat.dunya.title': 'World News — Global Economy and Politics',
  'seo.newsCat.dunya.desc': 'World developments that move the global economy and financial markets: geopolitics, trade policy and international economic decisions.',
  'seo.newsCat.enerji.title': 'Energy News — Oil, Natural Gas and Power',
  'seo.newsCat.enerji.desc': 'Brent and WTI crude prices, the natural gas market, OPEC decisions, electricity and renewable energy sector news as it happens.',
  'seo.newsCat.teknoloji.title': 'Technology News — Tech Stocks and Artificial Intelligence',
  'seo.newsCat.teknoloji.desc': 'Technology companies, artificial intelligence investment, the semiconductor sector and the developments driving Nasdaq tech stocks.',
  'seo.newsCat.kripto.title': 'Crypto News — Bitcoin and Altcoin Coverage',
  'seo.newsCat.kripto.desc': 'Breaking cryptocurrency news on Bitcoin, Ethereum and the altcoin market, plus regulation developments and blockchain sector coverage.',
  'seo.newsCat.forex-emtia.title': 'Forex and Commodity News — Pairs, Gold, Oil',
  'seo.newsCat.forex-emtia.desc': 'Dollar, euro and sterling currency pairs, gold and silver prices, plus agricultural and industrial commodity market news.',
  'seo.newsCat.rehber.title': 'Investing Guide News — Education and Tips',
  'seo.newsCat.rehber.desc': 'Investing guide content for beginners and experienced investors: strategy, risk management and clear explanations of market terminology.',
  'news.categoryBreadcrumb': 'Category',
  'news.backToAll': 'Back to all news',
  'seo.guidesTitle': 'Investment Guides — Stocks, Crypto and Forex',
  'seo.guidesDesc': 'Comprehensive guides for investing in stocks, crypto, currencies and commodities. For all investors from beginner to advanced.',
  'seo.stockTitle': '{symbol} Stock — Live Price and Chart',
  'seo.stockDesc': '{symbol} stock live price, daily change, trading volume and historical chart. Open, high and low levels with up-to-date market data.',
  'seo.indexDesc': '{name} index live price, charts and constituent stocks.',
  'seo.cryptoDesc': '{name} ({symbol}) live price, market capitalisation, circulating supply and 24-hour change chart. Current data from the crypto market.',
  'seo.forexDesc': '{pair} exchange rate live price and charts.',
  'seo.exchangeDesc': '{name} exchange indices, stocks and trading hours.',
  'seo.contactDesc': 'Contact details, support and partnership channels for Borsaya.com. Reach us directly with questions, suggestions or to report an issue.',

  // Guides
  'guides.title': 'Investment Guides',
  'guides.desc': 'Comprehensive guides for investing in stocks, crypto, currencies and commodities.',
  'guides.readMore': 'Read More',
  'guides.empty': 'No guide content available yet.',

  // Instrument About
  'instrument.aboutTitle': 'About:',
  'instrument.faqTitle': 'Frequently Asked Questions',

  // Homepage SEO content
  // T5 karşılığı (EN): H1 hedef kelimeleri title ile paylaşır.
  'home.introTitle': 'Live Stock, Exchange Rates & Crypto Prices: Global Markets in One Platform',
  'home.introP1': 'Borsaya.com is an independent financial platform providing real-time and delayed data from global markets, covering over 80 exchanges worldwide. Track stock prices, index values and market statistics from the New York Stock Exchange (NYSE), NASDAQ, Xetra, Euronext, London Stock Exchange (LSE), Tokyo Stock Exchange (TSE) and many more international exchanges.',
  'home.introP2': 'Access all the information you need with exchange rates, cryptocurrency prices, commodity data and latest financial news. Analyze the daily performance of major indices such as S&P 500, Dow Jones, DAX, FTSE 100 and Nikkei 225 with detailed charts.',
  'home.introP3': 'Gold, oil, silver and other commodity prices; USD/TRY, EUR/USD, GBP/USD currency pairs; Bitcoin, Ethereum and other cryptocurrencies — monitor all financial instruments across global markets from a single platform. Stay updated with breaking news and economic developments.',
  'home.marketsTitle': 'Global Indices and Shares',
  'home.marketsP1': 'Track major indices across global stock markets in real time — Dow Jones Industrial Average, S&P 500, NASDAQ Composite from US markets, DAX 40, FTSE 100, CAC 40, Euro Stoxx 50 from European markets, Nikkei 225, Hang Seng, Shanghai Composite, KOSPI from Asian markets and more. Compare daily, weekly, monthly and yearly performance changes for each index.',
  'home.marketsP2': 'We offer detailed charting and technical analysis tools for stock investors. View real-time prices, trading volumes and market capitalizations for thousands of global shares including Apple, Microsoft, Tesla, Amazon, Nvidia and Google.',
  'home.forexTitle': 'Exchange Rates and Cryptocurrencies',
  'home.forexP1': 'Monitor live exchange rates for all major currency pairs including USD/TRY, EUR/TRY and GBP/TRY. Compare current prices, market capitalizations and 24-hour change rates for popular cryptocurrencies such as Bitcoin (BTC), Ethereum (ETH), Solana (SOL), Binance Coin (BNB), Ripple (XRP), Cardano (ADA) and Dogecoin (DOGE).',
  'home.forexP2': 'Track commodity prices for gold (XAU/USD), crude oil (Brent), silver, copper and natural gas in real time. Analyze the impact of global economic developments on commodity prices with live data. Our platform brings together data from 82 exchanges across 7 different regions, offering investors a comprehensive market overview.',

  // Cookie Consent
  'cookie.title': 'Cookie Usage',
  'cookie.text': 'We use cookies to improve your experience and analyze site traffic. IP address, location and usage data may be collected.',
  'cookie.accept': 'Accept',
  'cookie.reject': 'Decline',
  'cookie.privacy': 'Privacy Policy',

  // Accessibility (aria-labels)
  'aria.prevTicker': 'Previous ticker',
  'aria.nextTicker': 'Next ticker',
  'aria.prevNews': 'Previous news',
  'aria.nextNews': 'Next news',
  'aria.toggleTheme': 'Toggle theme',
  'aria.search': 'Search',
  'aria.closeSearch': 'Close search',
  'aria.clearSearch': 'Clear search',
  'aria.moreOptions': 'More options',
  'aria.darkMode': 'Switch to dark mode',
  'aria.lightMode': 'Switch to light mode',
}

export const translations: Record<string, Record<string, string>> = { tr, en }

export function t(key: string, lang: string): string {
  return translations[lang]?.[key] ?? translations['tr']?.[key] ?? key
}
